/**
 * Time constants
 *
 * @constant {number} oneMinuteInMs - One minute in milliseconds.
 * @constant {number} oneSecondInMs - One second in milliseconds.
 */
export const oneMinuteInMs = 60 * 1000;
export const oneSecondInMs = 1000;
